import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import WhatsappPopup from './WhatsappPopup';
import { WHATSAPP_LINKS } from '../config/whatsapp-config';
import './PageFooter.css';

function PageFooter() {
  const [showWhatsappPopup, setShowWhatsappPopup] = useState(false);
  const footerRef = useRef(null);
  const location = useLocation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    // Reset animations
    if (footerRef.current) {
      const footer = footerRef.current;
      const brand = footer.querySelector('.footer-brand');
      const linksGrid = footer.querySelector('.footer-links-grid');
      const newsletter = footer.querySelector('.footer-newsletter');
      const socialIcons = footer.querySelectorAll('.footer-social-icon');

      // Remove animate classes
      footer.classList.remove('animate');
      brand?.classList.remove('animate');
      linksGrid?.classList.remove('animate');
      newsletter?.classList.remove('animate');
      socialIcons.forEach(icon => icon.classList.remove('animate'));

      // Trigger reflow to restart animation
      void footer.offsetWidth;

      // Add animate classes
      requestAnimationFrame(() => {
        footer.classList.add('animate');
        brand?.classList.add('animate');
        linksGrid?.classList.add('animate');
        newsletter?.classList.add('animate');
        socialIcons.forEach(icon => icon.classList.add('animate'));
      });
    }
  }, [location.pathname]);

  return (
    <>
      <footer ref={footerRef} className="page-footer">
        <div className="footer-content">
          {/* Left Section - Brand */}
          <div className="footer-brand">
            <div className="footer-brand-text">
              <h3 className="footer-brand-title">JULIAN PROPST</h3>
            </div>
            
            {/* Social Icons */}
            <div className="footer-social-icons">
              <a 
                href="https://www.youtube.com/@JulianProwick" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-social-icon"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
              <a 
                href="https://www.instagram.com/julianpropst/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-social-icon"
              >
                <img src="/img/social.svg" alt="Instagram" />
              </a>
            </div>
          </div>

          {/* Footer Links Grid */}
          <div className="footer-links-grid">
            {/* Contact Section */}
            <div className="footer-section">
              <h5 className="footer-section-title">CONTACT</h5>
              <ul className="footer-links">
                <li><a href="mailto:julian@propst.com">Email</a></li>
                <li><a href="https://www.youtube.com/@JulianProwick" target="_blank" rel="noopener noreferrer">YouTube</a></li>
                <li><a href="https://www.instagram.com/julianpropst/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
              </ul>
            </div>

            {/* Sections Section */}
            <div className="footer-section">
              <h5 className="footer-section-title">PAGES</h5>
              <ul className="footer-links">
                <li><a href="#home" onClick={scrollToTop}>Home</a></li>
                <li><Link to="/julian">Beginnings</Link></li>
                <li><a href="#projekte" onClick={scrollToTop}>Projects</a></li>
              </ul>
            </div>

            {/* Legal Section */}
            <div className="footer-section">
              <h5 className="footer-section-title">LEGAL</h5>
              <ul className="footer-links">
                <li><Link to="/imprint">Legal/Imprint</Link></li>
                <li><Link to="/privacy">Privacy</Link></li>
                <li><Link to="/terms">Terms</Link></li>
              </ul>
            </div>
          </div>

          {/* Newsletter Section */}
          <div className="footer-newsletter">
            <h5 className="footer-newsletter-title">GET IN TOUCH</h5>
            <p className="footer-newsletter-description">
              Ready to scale? Book a ScaleUp Call and let's get started together
            </p>
            
            <button 
              className="newsletter-button"
              onClick={(e) => {
                e.preventDefault();
                const angeboteSection = document.getElementById('angebote');
                if (angeboteSection) {
                  angeboteSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }}
            >
              Contact the Team
            </button>
            
            <p className="newsletter-privacy">
            This service is offered exclusively to businesses (B2B).
            </p>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>© 2025 Julian Propst - Personal Branding. All rights reserved.</p>
            <p className="footer-slogan">Build authentic. Sell authentic.</p>
            <p className="footer-legal-notice">
              This website provides personal branding and informational content. 
              All commercial services are offered exclusively to businesses and entrepreneurs (B2B). 
              No consumer services are provided. 
              All paid sessions are delivered through BonusClub LLC, a Florida Limited Liability Company, 
              operating globally from the United States and not targeting users in any specific country or jurisdiction.
            </p>
            <p className="footer-credit">Website created with ♥ by <a href="https://salesgod.co" target="_blank" rel="noopener noreferrer">BonusClub.io</a></p>
          </div>
        </div>
      </footer>

      <WhatsappPopup 
        isOpen={showWhatsappPopup} 
        onClose={() => setShowWhatsappPopup(false)}
        riderLink={WHATSAPP_LINKS.rider.url}
        trainerLink={WHATSAPP_LINKS.trainer.url}
      />
    </>
  );
}

export default PageFooter;